import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDetailsService } from './user-details.service';
import { HeaderService } from './header.service';
import { Observable, catchError, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  apiURL = environment.oneLogApi;
  //apiURL = environment.jsonServer;

  constructor(
    private http: HttpClient,
    private userDetails: UserDetailsService,
    private headerService: HeaderService
  ) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  //Get Request
  getRequest(url: string): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http
      .get<any>(this.apiURL + url, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  postRequest(
    url: string = '',
    postData: any = [],
    urlParams: string = ''
  ): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    return this.http
      .post<any>(this.apiURL + url + urlParams, postData, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  download(
    url: string,
    postData: any = [],
    urlParams: string = '',
    downloadFileName: string = 'Downloaded-One-log-report'
  ) {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };
    const headers = new HttpHeaders()
      //.set('Content-Type', 'text/plain; charset=utf-8')
      .set('Content-Type', 'application/json')
      .set('Authorization', this.userDetails.getUserToken())
      .set('userToken', this.userDetails.getUser());

    const body = JSON.stringify(postData);
    
    this.http
      .post(
        `${this.apiURL}${url}${urlParams}`,
        body,
        { headers, responseType: 'blob' }
      )
      .subscribe((resp: any) => {
        saveAs(resp, downloadFileName);
      });
  }

  postCheckToken(
    url: string = '',
    postData: any = [],
    urlParams: string = '',
    user: string = '',
    token: string = ''
  ): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: token,
      userToken: user,
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    return this.http
      .post<any>(this.apiURL + url + urlParams, postData, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  //Post Request

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
